import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { MonetizationType } from '@/@types/graphql-types';
import { useQuery } from '@/helpers/composables/useApollo';

import {
	TitleListOfferProviderFragment,
	GetTitleListOfferProvidersQuery,
	GetTitleListOfferProvidersDocument,
	GetTitleListOfferProvidersQueryVariables,
} from '@/pages/graphql/queries/GetTitleListOfferProviders.query';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListOffersComparison',
  props: {
    listId: null,
    listSize: null,
    chartSize: { default: 5 }
  },
  setup(__props: any) {

const props = __props as { listId: string, listSize: number, chartSize: number };



const { country } = storeToRefs(useLanguageStore());

const queryVariables = computed<GetTitleListOfferProvidersQueryVariables>(() => ({
	nodeId: props.listId,
	country: country.value,
	first: props.listSize,
	offersFilter: {
		bestOnly: true,
		preAffiliate: true,
		monetizationTypes: [
			MonetizationType.Flatrate,
			MonetizationType.FlatrateAndBuy,
			MonetizationType.Ads,
			MonetizationType.Free,
		],
	},
}));

const { result } = useQuery<GetTitleListOfferProvidersQuery, GetTitleListOfferProvidersQueryVariables>(
	GetTitleListOfferProvidersDocument,
	queryVariables
);

const listOffers = computed<NonNullable<TitleListOfferProviderFragment>[]>(() => {
	const genericTitleListData = result.value?.node;

	return genericTitleListData?.__typename === 'GenericTitleList' ? genericTitleListData.titles?.edges ?? [] : [];
});

const offerAggregate = computed(() => {
	const aggregate: { [id: string]: { shortName: string; count: number; name: string } } = {};

	listOffers.value
		.flatMap(({ nodeV2 }) => nodeV2.flatrate)
		.forEach(offer => {
			if (!(offer.package.id in aggregate)) {
				aggregate[offer.package.id] = {
					shortName: offer.package.shortName,
					count: 0,
					name: offer.package.clearName,
				};
			}

			aggregate[offer.package.id].count++;
		});

	const result = Object.values(aggregate);
	result.sort((a, b) => b.count - a.count);

	return result;
});

const topProvider = computed(() => offerAggregate.value[0] ?? { id: '', count: 0, name: '' });

return { __sfc: true,props, country, queryVariables, result, listOffers, offerAggregate, topProvider, ProviderIcon }
}

})